module.exports = __webpack_public_path__ + "img/collapsed-tasks.71971284.svg";